"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSlotOccurencesBetween = void 0;
const rrule_1 = require("rrule");
const format_to_tz_1 = require("./format-to-tz");
const parse_rrule_1 = require("./parse-rrule");
const timezone_date_1 = require("./timezone-date");
/**
 * Get occurences between interval
 * @param from date in UTC
 * @param to date in UTC
 * @returns
 */
const getSlotOccurencesBetween = ({ slot, allday, from, to, timezone = 'Europe/Paris', }) => {
    // Check rrule with calendar config
    const result = (0, parse_rrule_1.parseRRule)({
        rrule: (0, format_to_tz_1.formatRRuleToTz)({
            rrule: slot.rrule,
            allday: slot.allday,
            timezone,
        }),
    });
    if (!result) {
        console.log('Cannot parse event rrule', slot.id);
        return [];
    }
    const rruleSet = new rrule_1.RRuleSet();
    rruleSet.rrule(result.rrule);
    if (Array.isArray(slot.exdate)) {
        for (const exdate of slot.exdate) {
            let exdateTz;
            if (slot.allday) {
                exdateTz = (0, timezone_date_1.formatToDateInTz)({
                    date: exdate,
                    timezone,
                });
            }
            else {
                exdateTz = (0, timezone_date_1.formatToDateTimeInTz)({
                    date: exdate,
                    timezone,
                });
            }
            rruleSet.exdate(new Date(exdateTz));
        }
    }
    const period = {};
    if (from) {
        const _form = allday
            ? (0, timezone_date_1.formatToDateInTz)({
                date: from,
                timezone: timezone,
            })
            : from;
        period.from = new Date(_form);
    }
    if (to) {
        const _to = allday
            ? (0, timezone_date_1.formatToDateInTz)({
                date: to,
                timezone: timezone,
            })
            : to;
        period.to = new Date(_to);
    }
    let dates = [];
    if (period.from && period.to) {
        dates = rruleSet.between(period.from, period.to, true);
    }
    else if (period.from) {
        const occAfter = rruleSet.after(period.from, true);
        if (occAfter) {
            dates = [occAfter];
        }
    }
    else if (period.to) {
        const occBefore = rruleSet.before(period.to, true);
        if (occBefore) {
            dates = [occBefore];
        }
    }
    return dates;
};
exports.getSlotOccurencesBetween = getSlotOccurencesBetween;
